import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import GetIcon from "../../../../utils/Icon";
import Tab1 from "./Tab1";
import Tab2 from "./Tab2";
import Tab3 from "./Tab3";
import Tab4 from "./Tab4";
import printerimg from "../../../../assets/print.png";
import {
  useTotalSupplierGroupListMutation,
  useTotalTerritoryListMutation,
  useTotalCurrencyListMutation,
  usePriceDetailsListMutation,
  useTotalBankAccountListMutation,
  useItemTaxCategoryMutation,
  useTotalTaxWithholdingCategoryListMutation,

  useItemCompanyMutation,
  useCountryListMutation,
  useItemGSTHSNCodeMutation,
  usePostCreateSupplierMutation,
} from "../../../../store/api/itemapi";
import ApiResponseBox from "../../../../Components/ApiResponseBox";
import Button from "../../../../Core/Button/Button";
import FormLayout from "../../../../Core/Layout/FormLayout";

const CreateForm = () => {
  const [tab, settab] = useState(1);
  const navigate = useNavigate();
  const [podate, setpodate] = useState(new Date().toISOString().split("T")[0]);
  const [error, setError] = useState("");
  const [ptype, setptype] = useState("Error");
  const [finalstep, setfinalstep] = useState(false);
  const [showError, setShowError] = useState(false);

  // api varibale
  const [ItemSupplierGroupApi] = useTotalSupplierGroupListMutation();
  const [TerritoryListApi] = useTotalTerritoryListMutation();
  const [CurrencyListApi] = useTotalCurrencyListMutation();
  const [PriceDetailsListApi] = usePriceDetailsListMutation();
  const [BankAccountListApi] = useTotalBankAccountListMutation();
  const [ItemTaxCategoryApi] = useItemTaxCategoryMutation();
  const [TaxWithholdingCategoryApi] = useTotalTaxWithholdingCategoryListMutation();

  const [ItemGSTHSNCodeApi] = useItemGSTHSNCodeMutation();
  const [CompanyListApi] = useItemCompanyMutation();

  const [CountryListApi] = useCountryListMutation();
  const [CreateSupplier] = usePostCreateSupplierMutation();


  // for Tab1
  const [SupplierName, setSupplierName] = useState("");
  const [SupplierGroup_list, setSupplierGroup_list] = useState([]);
  const [select_SupplierGroup, setselect_SupplierGroup] = useState("");
  const [SupplierType, setSupplierType] = useState("");
  const [Territory_list, setTerritory_list] = useState([]);
  const [select_Territory, setselect_Territory] = useState("");
  const [IsTransporter, setIsTransporter] = useState("");
  const [BillingCurrency_list, setBillingCurrency_list] = useState([]);
  const [select_BillingCurrency, setselect_BillingCurrency] = useState("");
  const [DefaultCompanyBankAccount_list, setDefaultCompanyBankAccount_list] = useState([]);
  const [select_DefaultCompanyBankAccount, setselect_DefaultCompanyBankAccount] = useState("");
  const [DefaultPriceList_list, setDefaultPriceList_list] = useState([]);
  const [select_DefaultPriceList, setselect_DefaultPriceList] = useState("");
  const [IsInternalSupplier, setIsInternalSupplier] = useState("");
  const [RepresentsCompany_list, setRepresentsCompany_list] = useState([]);
  const [select_RepresentsCompany, setselect_RepresentsCompany] = useState("");
  const [Website, setWebsite] = useState("");
  const [SupplierDetails, setSupplierDetails] = useState("");

  // for Tab2
  const [SupplierPrimaryAddress_list, setSupplierPrimaryAddress_list] = useState([]);
  const [select_SupplierPrimaryAddress, setselect_SupplierPrimaryAddress] = useState("");
  const [SupplierPrimaryContact_list, setSupplierPrimaryContact_list] = useState([]);
  const [select_SupplierPrimaryContact, setselect_SupplierPrimaryContact] = useState("");

  // for Tab3
  const [TaxID, setTaxID] = useState("");
  const [TaxCategory_list, setTaxCategory_list] = useState([]);
  const [select_TaxCategory, setselect_TaxCategory] = useState("");
  const [TaxWithholdingCategory_list, setTaxWithholdingCategory_list] = useState([]);
  const [select_TaxWithholdingCategory, setselect_TaxWithholdingCategory] = useState("");
  const [GSTIN_UIN, setGSTIN_UIN] = useState("");
  const [PAN, setPAN] = useState("");
  const [GSTCategory, setGSTCategory] = useState("");

  // for Tab4
  const [AllowPurchaseInvoiceCreationWithoutPurchaseOrder, setAllowPurchaseInvoiceCreationWithoutPurchaseOrder] = useState("");
  const [IsFrozen, setIsFrozen] = useState("");
  const [AllowPurchaseInvoiceCreationWithoutPurchaseReceipt, setAllowPurchaseInvoiceCreationWithoutPurchaseReceipt] = useState("");
  const [Disabled, setDisabled] = useState("");
  const [BlockSupplier, setBlockSupplier] = useState("");
  const [HoldType, setHoldType] = useState("");
  const [ReleaseDate, setReleaseDate] = useState("");


  const [fieldErrors, setFieldErrors] = useState({
    SupplierName: false,
    SupplierGroup: false,
    SupplierType: false,
    Territory: false,
  });
  // for api

  useEffect(() => {
    const getItemSupplierGroup = async () => {
      const ItemSupplierGroupApiData = await ItemSupplierGroupApi();
      setSupplierGroup_list(ItemSupplierGroupApiData.data.data);
    };

    const getItemTerritory = async () => {
      const ItemTerritoryApiData = await TerritoryListApi();
      setTerritory_list(ItemTerritoryApiData.data.data);
    };

    const getItemBillingCurrency = async () => {
      const ItemBillingCurrencyApiData = await CurrencyListApi()
      setBillingCurrency_list(ItemBillingCurrencyApiData.data.data);
    }
    const getItemDefaultCompanyBankAccount = async () => {
      const ItemDefaultCompanyBankAccountApiData = await BankAccountListApi()
      setDefaultCompanyBankAccount_list(ItemDefaultCompanyBankAccountApiData.data.data);
    }
    const getItemDefaultPriceList = async () => {
      const ItemDefaultPriceListApiData = await PriceDetailsListApi()
      setDefaultPriceList_list(ItemDefaultPriceListApiData.data.data);
    }
    const getItemSupplierPrimaryAddress = async () => {
      const ItemSupplierPrimaryAddressApiData = await CountryListApi()
      setSupplierPrimaryAddress_list(ItemSupplierPrimaryAddressApiData.data.data);
    }

    const getItemSupplierPrimaryContact = async () => {
      const ItemSupplierPrimaryContactApiData = await CountryListApi()
      setSupplierPrimaryContact_list(ItemSupplierPrimaryContactApiData.data.data);
    }
    const getItemTaxCategory = async () => {
      const ItemTaxCategoryApiData = await ItemTaxCategoryApi()
      setTaxCategory_list(ItemTaxCategoryApiData.data.data);
    }

    const getItemTaxWithholdingCategory = async () => {
      const ItemTaxWithholdingCategoryApiData = await TaxWithholdingCategoryApi()
      setTaxWithholdingCategory_list(ItemTaxWithholdingCategoryApiData.data.data);
    }

    const getItemRepresentsCompany = async () => {
      const ItemRepresentsCompanyApiData = await CompanyListApi()
      setRepresentsCompany_list(ItemRepresentsCompanyApiData.data.data);
    }
    getItemSupplierGroup();
    getItemTerritory();
    getItemBillingCurrency();
    getItemDefaultCompanyBankAccount();
    getItemDefaultPriceList();
    getItemSupplierPrimaryAddress();
    getItemSupplierPrimaryContact();
    getItemTaxCategory();
    getItemTaxWithholdingCategory();
    getItemRepresentsCompany();
  }, []);

  const [po_response, setpo_response] = useState("");

  const handleSubmit = async () => {

    setFieldErrors({
      SupplierName: false,
      SupplierGroup: false,
      SupplierType: false,
      Territory: false,
    });

    let hasError = false;
    const newErrors = {
      SupplierName: !SupplierName,
      SupplierGroup: !select_SupplierGroup,
      SupplierType: !SupplierType,
      Territory: !select_Territory,
    };
    const FirsthasInvalidItem = "";

    setFieldErrors(newErrors);
    hasError = Object.values(newErrors).some(error => error);


    if (!SupplierName) {
      setptype("Error");
      setError("Please fill Supplier Name.");
      setShowError(true);
      return;
    }



    const payload = {
      naming_series: "SUP-.YYYY.-", // start Tab1
      supplier_name: SupplierName,
      country: select_Territory,
      supplier_group: select_SupplierGroup,
      supplier_type: SupplierType,
      is_transporter: IsTransporter,
      image: "",
      default_currency: select_BillingCurrency,
      default_bank_account: select_DefaultCompanyBankAccount,
      default_price_list: select_DefaultPriceList,
      is_internal_supplier: IsInternalSupplier,
      represents_company: select_RepresentsCompany,
      //extra 
      // companies: [   
      //     {
      //         "company": "Main Company"
      //     },
      //     {
      //         "company": "Subsidiary A"
      //     }
      // ], 
      //end extra
      supplier_details: SupplierDetails,
      website: Website,
      // language: "en", //extra


      supplier_primary_address: "", //start Tab 2 select_SupplierPrimaryAddress
      supplier_primary_contact: "", // Tab2 select_SupplierPrimaryContact

      tax_id: TaxID, //start Tab3
      tax_category: select_TaxCategory,
      tax_withholding_category: select_TaxWithholdingCategory,
      gstin: GSTIN_UIN,
      pan: PAN,
      gst_category: GSTCategory,

      // gst_transporter_id: "",  //extra
      // is_reverse_charge_applicable: "",//extra
      // payment_terms: "",//extra
      //extra
      // accounts: [
      //     {
      //         "company": "Main Company",
      //         "account": "Creditors - Tech",
      //         "advance_account": "Advances Paid - Tech"
      //     }
      // ], 
      //end extra
      // for Tab4
      allow_purchase_invoice_creation_without_purchase_order: AllowPurchaseInvoiceCreationWithoutPurchaseOrder,
      allow_purchase_invoice_creation_without_purchase_receipt: AllowPurchaseInvoiceCreationWithoutPurchaseReceipt,
      is_frozen: IsFrozen,
      disabled: Disabled,
      on_hold: BlockSupplier,
      hold_type: HoldType,
      release_date: ReleaseDate,
      // end Tab4


      //extra
      // portal_users: [
      //     {
      //         "user": "supplier1@example.com"
      //     },
      //     {
      //         "user": "supplier2@example.com"
      //     }
      // ]
      // end extra


    };

    console.log('create supplier payload:', payload)
    try {
      const response = await CreateSupplier(payload); // RTK mutation or fetch

       function stripHTML(html) {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.body.textContent || "";
}

if (response.error) {
  let errorMessage = "Creation failed";

  if (response.error.data && response.error.data._server_messages) {
    try {
      const serverMessages = JSON.parse(response.error.data._server_messages);
      if (Array.isArray(serverMessages) && serverMessages.length > 0) {
        const parsedMessage = JSON.parse(serverMessages[0]);
        errorMessage = parsedMessage.message || errorMessage;
      }
    } catch (e) {
      console.warn("Failed to parse _server_messages", e);
    }
  } else {
    errorMessage =
      response.error.data?.message ||
      response.error.data?.exception ||
      errorMessage;
  }

  // ✅ Strip any HTML tags like <strong> from the final error message
  errorMessage = stripHTML(errorMessage);

  setptype("Error");
  setError(errorMessage);
  setShowError(true);
  return;
}

      setpo_response(response.data);
      setError("Supplier created successfully!");
      setptype("Success");
      setShowError(true);
      // Navigate after a short delay (e.g., 2 seconds)
      setTimeout(() => {
        navigate("/master/supplier/supplier-list"); // 🔁 Replace with your actual route
      }, 2000);
    } catch (err) {
      setError(err?.data?.message || "Unexpected error occurred.");
      setptype("Error");
      setShowError(true);
    }

  };

  return (
    <FormLayout
      title="New Supplier"
      breadcrumbs={[
        { label: "Supplier"},
        { label: "Supplier List", url: "/master/supplier/supplier-list" },
      ]}
      status={'hide'}
      finalStep={finalstep}
      actionButtons={
        <>
          <Button
            className="custom-view-btn d-flex"
            iconName="IoMdArrowDropdown"
            iconPosition="right"
            style={{ gap: "2px" }}
            iconSize={14}
          >
            View
          </Button>
          <Button
            onClick={() => { }}
            to="/"
            state={po_response?.result}
            style={{ backgroundColor: "#fff", height: "28px" }}
            className="custom-btn-00989blue"
            display={finalstep ? "flex" : "none"}
          >
            + Create
          </Button>

          <Button
            className="custom-btn-bluecolor d-flex"
            iconName="BiCloudUpload"
            style={{ gap: "2px" }}
            iconSize={14}
          >
            Upload
          </Button>

          <Button
            className="createbtn d-flex"
            style={{ gap: "2px", height: "28px" }}
            iconName="GrCopy"
            iconSize={12}
          >
            Duplicate
          </Button>

          <Button
            className="custom-btn-00989"
            onClick={handleSubmit}
            iconName="LuFilePlus2"
            style={{ gap: "2px", height: "28px" }}
            iconSize={12}
            display={finalstep ? "none" : "flex"}
          >
            {po_response.result ? "Submit" : "Save"}
          </Button>

          <Button
            to="/"
            className="px-2"
            imgSrc={printerimg}
            imgStyle={{ width: "21px" }}
          />
        </>
      }
    >
      <div className="d-flex flex-column" style={{ width: "100%", backgroundColor: "#fff",flexGrow:'1' }}>
        <div className="col-12 p-0" style={{ backgroundColor: "#eff4f9" }}>
          <div className="d-flex justify-content-between align-items-end ">
            <ul
              className="nav nav-tabs"
              style={{ color: "white", border: "none" }}
            >
              <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
                <a
                  className={
                    tab == 1
                      ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner"
                      : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"
                  }
                  onClick={() => {
                    settab(1);
                  }}
                  href="javascript:void(0);"
                >
                  General Details
                  {tab == 1 ? (
                    <GetIcon iconName="MdKeyboardArrowDown" size={15} />
                  ) : (
                    <GetIcon iconName="MdKeyboardArrowRight" size={15} />
                  )}
                </a>
              </li>
              <li className="nav-item-tab-custom pb-0 d-flex align-items-end border-radius-top-corner">
                <a
                  className={
                    tab == 2
                      ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner"
                      : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"
                  }
                  onClick={() => {
                    settab(2);
                  }}
                  href="javascript:void(0);"
                >
                  Address & Contact{" "}
                  {tab == 2 ? (
                    <GetIcon iconName="MdKeyboardArrowDown" size={15} />
                  ) : (
                    <GetIcon iconName="MdKeyboardArrowRight" size={15} />
                  )}
                </a>
              </li>
              <li className="nav-item-tab-custom pb-0 d-flex align-items-end border-radius-top-corner">
                <a
                  className={
                    tab == 3
                      ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner"
                      : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"
                  }
                  onClick={() => {
                    settab(3);
                  }}
                  href="javascript:void(0);"
                >
                  Tax{" "}
                  {tab == 3 ? (
                    <GetIcon iconName="MdKeyboardArrowDown" size={15} />
                  ) : (
                    <GetIcon iconName="MdKeyboardArrowRight" size={15} />
                  )}
                </a>
              </li>
              <li className="nav-item-tab-custom pb-0 d-flex align-items-end border-radius-top-corner">
                <a
                  className={
                    tab == 4
                      ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner"
                      : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"
                  }
                  onClick={() => {
                    settab(4);
                  }}
                  href="javascript:void(0);"
                >
                  Settings{" "}
                  {tab == 4 ? (
                    <GetIcon iconName="MdKeyboardArrowDown" size={15} />
                  ) : (
                    <GetIcon iconName="MdKeyboardArrowRight" size={15} />
                  )}
                </a>
              </li>
            </ul>

            <div
              className="d-flex align-items-center mb-2 px-3"
              style={{ gap: "2px", fontSize: "12px" }}
            >
              <span style={{ position: "relative", top: "-1px" }}>
                <GetIcon iconName="CgAttachment" size={12} />
              </span>
              <span className=" fw-semibold" style={{ color: "#391F84" }}>
                Attachments
              </span>
            </div>
          </div>
        </div>

        <div
          className="row d-flex justify-content-between"
          style={{ marginTop: "14px" }}
        >
          <div
            className="col-12 "
            style={{
              visibility: tab == 1 ? "visible" : "hidden",
              height: tab == 1 ? "auto" : "0px",
            }}
          >
            <div className="sidebarbox m-0 px-4 py-2">
              <Tab1
                SupplierName={{
                  SupplierName: SupplierName,
                  setSupplierName: setSupplierName,
                  SupplierName: SupplierName,
                  Error: fieldErrors.SupplierName,
                }}
                IsTransporter={{
                  IsTransporter: IsTransporter,
                  setIsTransporter: setIsTransporter,
                  IsTransporter: IsTransporter,
                  Error: fieldErrors.IsTransporter,
                }}
                SupplierGroup={{
                  SupplierGroup_list: SupplierGroup_list,
                  setselect_SupplierGroup: setselect_SupplierGroup,
                  select_SupplierGroup: select_SupplierGroup,
                  Error: fieldErrors.SupplierGroup,
                }}
                SupplierType={{
                  SupplierType: SupplierType,
                  setSupplierType: setSupplierType,
                  SupplierType: SupplierType,
                  Error: fieldErrors.SupplierType,
                }}
                Territory={{
                  Territory_list: Territory_list,
                  setselect_Territory: setselect_Territory,
                  select_Territory: select_Territory,
                  Error: fieldErrors.Territory,
                }}
                BillingCurrency={{ BillingCurrency_list: BillingCurrency_list, setselect_BillingCurrency: setselect_BillingCurrency, select_BillingCurrency: select_BillingCurrency, Error: fieldErrors.BillingCurrency }}
                DefaultCompanyBankAccount={{ DefaultCompanyBankAccount_list: DefaultCompanyBankAccount_list, setselect_DefaultCompanyBankAccount: setselect_DefaultCompanyBankAccount, select_DefaultCompanyBankAccount: select_DefaultCompanyBankAccount, Error: fieldErrors.DefaultCompanyBankAccount }}
                DefaultPriceList={{ DefaultPriceList_list: DefaultPriceList_list, setselect_DefaultPriceList: setselect_DefaultPriceList, select_DefaultPriceList: select_DefaultPriceList, Error: fieldErrors.DefaultPriceList }}
                IsInternalSupplier={{
                  IsInternalSupplier: IsInternalSupplier,
                  setIsInternalSupplier: setIsInternalSupplier,
                  IsInternalSupplier: IsInternalSupplier,
                  Error: fieldErrors.IsInternalSupplier,
                }}
                RepresentsCompany={{ RepresentsCompany_list: RepresentsCompany_list, setselect_RepresentsCompany: setselect_RepresentsCompany, select_RepresentsCompany: select_RepresentsCompany, Error: fieldErrors.RepresentsCompany }}
                Website={{
                  Website: Website,
                  setWebsite: setWebsite,
                  Website: Website,
                  Error: fieldErrors.Website,
                }}
                SupplierDetails={{
                  SupplierDetails: SupplierDetails,
                  setSupplierDetails: setSupplierDetails,
                  SupplierDetails: SupplierDetails,
                  Error: fieldErrors.SupplierDetails,
                }}

              />
            </div>
          </div>

          <div
            className="col-12"
            style={{
              visibility: tab == 2 ? "visible" : "hidden",
              height: tab == 2 ? "auto" : "0px",
            }}
          >
            <div className="sidebarbox m-0 px-4 py-2">
              <Tab2
                SupplierPrimaryAddress={{ SupplierPrimaryAddress_list: SupplierPrimaryAddress_list, setselect_SupplierPrimaryAddress: setselect_SupplierPrimaryAddress, select_SupplierPrimaryAddress: select_SupplierPrimaryAddress, Error: fieldErrors.SupplierPrimaryAddress }}
                SupplierPrimaryContact={{ SupplierPrimaryContact_list: SupplierPrimaryContact_list, setselect_SupplierPrimaryContact: setselect_SupplierPrimaryContact, select_SupplierPrimaryContact: select_SupplierPrimaryContact, Error: fieldErrors.SupplierPrimaryContact }}
              />
            </div>
          </div>

          <div
            className="col-12"
            style={{
              visibility: tab == 3 ? "visible" : "hidden",
              height: tab == 3 ? "auto" : "0px",
            }}
          >
            <div className="sidebarbox m-0 px-4 py-2">
              <Tab3
                TaxID={{
                  TaxID: TaxID,
                  setTaxID: setTaxID,
                  TaxID: TaxID,
                  Error: fieldErrors.TaxID,
                }}
                TaxCategory={{ TaxCategory_list: TaxCategory_list, setselect_TaxCategory: setselect_TaxCategory, select_TaxCategory: select_TaxCategory, Error: fieldErrors.TaxCategory }}


                TaxWithholdingCategory={{ TaxWithholdingCategory_list: TaxWithholdingCategory_list, setselect_TaxWithholdingCategory: setselect_TaxWithholdingCategory, select_TaxWithholdingCategory: select_TaxWithholdingCategory, Error: fieldErrors.TaxWithholdingCategory }}
                GSTIN_UIN={{
                  GSTIN_UIN: GSTIN_UIN,
                  setGSTIN_UIN: setGSTIN_UIN,
                  GSTIN_UIN: GSTIN_UIN,
                  Error: fieldErrors.GSTIN_UIN,
                }}
                PAN={{
                  PAN: PAN,
                  setPAN: setPAN,
                  PAN: PAN,
                  Error: fieldErrors.PAN,
                }}
                GSTCategory={{ GSTCategory: GSTCategory, setGSTCategory: setGSTCategory, GSTCategory: GSTCategory, Error: fieldErrors.GSTCategory }}

              />
            </div>
          </div>

          <div
            className="col-12"
            style={{
              visibility: tab == 4 ? "visible" : "hidden",
              height: tab == 4 ? "auto" : "0px",
            }}
          >
            <div className="sidebarbox m-0 px-4 py-2">
              <Tab4
                AllowPurchaseInvoiceCreationWithoutPurchaseOrder={{
                  AllowPurchaseInvoiceCreationWithoutPurchaseOrder: AllowPurchaseInvoiceCreationWithoutPurchaseOrder,
                  setAllowPurchaseInvoiceCreationWithoutPurchaseOrder: setAllowPurchaseInvoiceCreationWithoutPurchaseOrder,
                  AllowPurchaseInvoiceCreationWithoutPurchaseOrder: AllowPurchaseInvoiceCreationWithoutPurchaseOrder,
                  Error: fieldErrors.AllowPurchaseInvoiceCreationWithoutPurchaseOrder,
                }}
                IsFrozen={{
                  IsFrozen: IsFrozen,
                  setIsFrozen: setIsFrozen,
                  IsFrozen: IsFrozen,
                  Error: fieldErrors.IsFrozen,
                }}
                AllowPurchaseInvoiceCreationWithoutPurchaseReceipt={{
                  AllowPurchaseInvoiceCreationWithoutPurchaseReceipt: AllowPurchaseInvoiceCreationWithoutPurchaseReceipt,
                  setAllowPurchaseInvoiceCreationWithoutPurchaseReceipt: setAllowPurchaseInvoiceCreationWithoutPurchaseReceipt,
                  AllowPurchaseInvoiceCreationWithoutPurchaseReceipt: AllowPurchaseInvoiceCreationWithoutPurchaseReceipt,
                  Error: fieldErrors.AllowPurchaseInvoiceCreationWithoutPurchaseReceipt,
                }}
                Disabled={{
                  Disabled: Disabled,
                  setDisabled: setDisabled,
                  Disabled: Disabled,
                  Error: fieldErrors.Disabled,
                }}
                BlockSupplier={{
                  BlockSupplier: BlockSupplier,
                  setBlockSupplier: setBlockSupplier,
                  BlockSupplier: BlockSupplier,
                  Error: fieldErrors.BlockSupplier,
                }}
                HoldType={{
                  HoldType: HoldType,
                  setHoldType: setHoldType,
                  HoldType: HoldType,
                  Error: fieldErrors.HoldType,
                }}
                ReleaseDate={{
                  ReleaseDate: ReleaseDate,
                  setReleaseDate: setReleaseDate,
                  ReleaseDate: ReleaseDate,
                  Error: fieldErrors.ReleaseDate,
                }}
              />
            </div>
          </div>
        </div>
      </div>

      <ApiResponseBox
        poptype={ptype}
        show={showError}
        errorMessage={error}
        onClose={() => setShowError(false)}
      />
    </FormLayout>
  );
};

export default CreateForm;
